import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {createTransferAuthTokenMutationType} from "./__graphql-types__/index.ts";

// This query is used in situations where we are about to change what
// domain the user is on, e.g. to go from www.khanacademy.org to
// es.khanacademy.org.  The reason we need this is that our auth
// cookies -- which are the thing that tell khan academy that you're
// logged in, and who you're logged in as -- are domain-specific;
// www.ka.org and es.ka.org do not share cookies.  The
// transfer-auth-token is part of the mechanism we use to
// automatically copy these auth cookies from one domain to another,
// so the user doesn't have to log in again on that domain.
// When redirecting into the canvas webapp, pass through
// canvasProfileKeyName (the same key-name that you pass into
// setCanvasInfo) so the new auth cookies can include necessary
// canvas data.
export const TRANSFER_AUTH_TOKEN_MUTATION: GqlOperation<
    createTransferAuthTokenMutationType["response"],
    createTransferAuthTokenMutationType["variables"]
> = gqlOp(gql`
    mutation createTransferAuthTokenMutation($canvasProfileKeyName: String) {
        createTransferAuthToken(canvasProfileKeyName: $canvasProfileKeyName) {
            token
        }
    }
`);
